import * as React from 'react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';


//Assets
import '../Assets/toggleSwitch.sass';

import { Card, Accordion, Row, Col, Button, Modal, DropdownButton, Dropdown, ListGroup, Container } from 'react-bootstrap';
import { FaFolder } from 'react-icons/fa';

//interfaces
import { IGroupConcept } from 'store/StateInterfaces';

// actions
import { loadGroupConceptsRequest } from '../Actions/Actions';
import { FcCamcorderPro, FcDocument, FcFolder, FcQuestions } from 'react-icons/fc';


interface IProps {
    group: any;
    index: any;
    loaded: boolean;
    concepts: Array<IGroupConcept>;
    actions: any;
}


class Group extends React.Component<IProps, {}> {


    componentDidMount() {
        if (!this.props.loaded) {
            this.props.actions.loadGroupConceptsRequest(this.props.group.id);
        }
    }


    public render() {
        return (

            <Card id={this.props.group.id} >

                <Accordion.Toggle as={Card.Header} eventKey={`${this.props.index}`}>
                    <Row>
                        <Col md={{ span: 8 }}>
                            <h5 className="groupListHandle">
                                {this.props.group.title}
                            </h5>
                        </Col>
                        <Col md={{ span: 2 }}>

                        </Col>
                        <Col md={{ span: 1 }}>

                        </Col>
                        <Col md={{ span: 1 }}>

                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ span: 12 }}>
                            <p style={{ color: 'grey' }}>
                                {this.props.group.description}
                            </p>
                        </Col>
                    </Row>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={`${this.props.index}`}>
                    <Card.Body style={{ marginLeft: '5%', width: '90%' }}>

                        <React.Fragment>

                            <Container style={{ minHeight: '20px' }} id={`conceptListContainer-${this.props.group.id}`}>
                                {!this.props.loaded ? null :
                                    this.props.concepts.map((concept, i) => {
                                        if (!concept.is_published) {
                                            return null;
                                        }
                                        let type_of_concept = 'section';
                                        let bit = 0;
                                        bit += (concept.quizzes.length != 0) ? 4 : 0;
                                        bit += (concept.videos.length != 0) ? 2 : 0;
                                        bit += (concept.pages.length != 0) ? 1 : 0;
                                        console.log(bit);

                                        type_of_concept = bit == 4 ? 'quiz' : type_of_concept;
                                        type_of_concept = bit == 2 ? 'video' : type_of_concept;
                                        type_of_concept = bit == 1 ? 'page' : type_of_concept;
                                        console.log(concept);
                                        let quizzes = concept.quizzes.map((quiz, j) => {
                                            return <FcQuestions type="button" size={20} onClick={() => window.location.href = `/frontend/concept/${concept.id}`
                                            } />
                                        });

                                        let videos = concept.videos.map((quiz, j) => {
                                            return <FcCamcorderPro type="button" size={20} onClick={() => window.location.href = `/frontend/concept/${concept.id}`
                                            } />
                                        });

                                        let pages = concept.pages.map((quiz, j) => {
                                            return <FcDocument type="button" size={20} onClick={() => window.location.href = `/frontend/concept/${concept.id}`
                                            } />
                                        });

                                        return (
                                            <Row key={concept.id} id={`${concept.id}`} className="border no-gutters" style={{ padding: '1%' }}>
                                                <Col style={{ marginLeft: '4%' }} xs={{ span: 1 }}>
                                                    <FcFolder className={type_of_concept == 'section' ? '' : "d-none"} size={20} />
                                                    <FcDocument className={type_of_concept == 'page' ? '' : "d-none"} size={20} />
                                                    <FcCamcorderPro className={type_of_concept == 'video' ? '' : "d-none"} size={20} />
                                                    <FcQuestions className={type_of_concept == 'quiz' ? '' : "d-none"} size={20} />
                                                </Col>
                                                <Col xs={{ span: 7 }}>
                                                    <Link to={`/frontend/concept/${concept.id}`}>
                                                        {concept.title}
                                                    </Link>
                                                </Col>
                                                <Col xs={{ span: 3 }} style={{ overflowX: 'auto' }}>
                                                    <div className="d-inline-flex">
                                                        {quizzes}
                                                        {videos}
                                                        {pages}
                                                    </div>
                                                </Col>
                                            </Row>
                                        );
                                    })
                                }
                            </Container>
                        </React.Fragment>


                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        );
    }
}

interface IReduxState {
    studentGroupConceptsMap: Map<number, Array<IGroupConcept>>;
}

const mapStateToProps = (state: IReduxState, { group, index }) => {
    if (state.studentGroupConceptsMap.has(group.id)) {
        return {
            loaded: true,
            concepts: state.studentGroupConceptsMap.get(group.id),
            group,
            index
        }
    }
    else {
        return {
            loaded: false,
            concepts: [],
            index,
            group
        }
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({ loadGroupConceptsRequest }, dispatch)
})


export default connect(mapStateToProps, mapDispatchToProps)(Group);